import { useEffect, useState } from "react";

// Tracks whether Shift is currently held. Pass enabled=false to detach the
// listeners (e.g. while a dropdown is closed); resets to false on window blur so
// a held-Shift state can't get stuck when focus leaves the tab.
export function useShiftHeld(enabled = true): boolean {
  const [shiftHeld, setShiftHeld] = useState(false);
  useEffect(() => {
    if (!enabled) {
      // oxlint-disable-next-line react/react-compiler -- blocks React Compiler; remove when fixed
      setShiftHeld(false);
      return;
    }
    const onKey = (e: KeyboardEvent) => setShiftHeld(e.shiftKey);
    const reset = () => setShiftHeld(false);
    window.addEventListener("keydown", onKey);
    window.addEventListener("keyup", onKey);
    window.addEventListener("blur", reset);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("keyup", onKey);
      window.removeEventListener("blur", reset);
    };
  }, [enabled]);
  return enabled && shiftHeld;
}
